import {
  AuthIdentifiers,
  AuthOptInType,
  AuthV2ChallengeType,
} from '@fhs-legacy/frontend/src/generated/graphql-gateway';

export type CreateOtpInput = {
  loginIdentifier: string;
  identifierType: AuthIdentifiers;
};

export type DateOfBirth = {
  dobMonth?: string;
  dobDay?: string;
  dobYear?: string;
};

export type SignUpInput = {
  name: string;
  email: string;
  phoneNumber: string;
  dob?: DateOfBirth;
  wantsPromotionalEmail?: boolean;
  firehouseSubsInsidersProgramOptIn?: boolean;
  agreesToTermsOfService?: boolean;
};

export type SignUpInputErrors = {
  name?: string;
  email?: string;
  phoneNumber?: string;
  dob?: DateOfBirth & { genericError?: string };
  wantsPromotionalEmail?: boolean;
  firehouseSubsInsidersProgramOptIn?: boolean;
  agreesToTermsOfService?: boolean;
};

export enum SignUpError {
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  USER_INVALID_AGE = 'USER_INVALID_AGE',
}

export type ValidatedIdentifiers = {
  phoneNumber?: string;
  emailAddress?: string;
};

export type IdentifyAuthChoice = {
  redactedName: string;
  redactedEmail: string;
};

export type IdentifyAuthJwt = {
  cognitoId: string;
  loginIdentifier: string;
  redactedIdentity: IdentifyAuthChoice;
  jwt: string;
};

export type LoginJwt = {
  identifierType: AuthIdentifiers;
  loginIdentifier: string;
  deviceId: string;
  validatedIdentifiers: ValidatedIdentifiers;
};

export { AuthIdentifiers, AuthOptInType, AuthV2ChallengeType };
